import './news-description.scss';

/**
 * version    1.0
 * class      <type> (news description)
 * classdesc
 */
export class NewsDescription {
  constructor() {
    this.setDropcap();
  }

  setDropcap() {
    const firstParagraph = document.querySelector(
      '.dettaglio-news__main .news-description p',
    );

    if (firstParagraph) {
      firstParagraph.setAttribute('data-dropcap', '');
    }
  }
}
